export enum DoNotCallListsSortBy {
  Total = 'total',
  ClientAssociated = 'client',
  UpdatedAt = 'updatedAt',
}

export enum DoNotCallListApplicableTo {
  AllClients = 'all-clients',
  SpecificClient = 'specific-client',
}
